import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { List, Typography, Modal } from 'antd'

import Spinner from '../../components/Spinner'
import CourseCard from '../../components/CourseCard'
import { useNavigate } from 'react-router-dom'
import { deleteCourse, getAllCourses } from '../../reducers/courseReducer'
import { unArchiveCourse } from '../../reducers/courseSettingsReducer'
import { ExclamationCircleOutlined } from '@ant-design/icons'

const { Title } = Typography
const { confirm } = Modal

const Archives = (props) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const archivedCourses = useSelector((state) =>
    Array.isArray(state.courses.data)
      ? state.courses.data.filter((course) => course.status !== 'published')
      : []
  )

  const loading = useSelector((state) => state.courses.loading)

  useEffect(() => {
    dispatch(getAllCourses('archived'))
  }, [])

  const unArchivedCourse = (courseId) => {
    dispatch(unArchiveCourse(courseId))
  }

  const removeCourse = (courseId) => {
    confirm({
      title: 'Are you sure you want to delete this course?',
      icon: <ExclamationCircleOutlined />,
      content: 'This action cannot be undone.',
      okText: 'Delete',
      okType: 'danger',
      cancelText: 'Cancel',
      onOk() {
        dispatch(deleteCourse(courseId))
      },
      onCancel() {
        return
      }
    })
  }

  if (loading) return <Spinner size="large" />

  return (
    <>
      <Title level={3}>Archives</Title>
      <List
        grid={{
          gutter: 24,
          column: 3,
          xs: 1,
          sm: 2,
          xxl: 5
        }}
        dataSource={archivedCourses}
        renderItem={(course) => (
          <List.Item>
            <CourseCard
              course={course}
              disableEnroll
              // onClick={() => navigate(`/app/course/${course.id}/modules`)}
              unarchive={() => unArchivedCourse(course.id)}
              isArchivePage={true}
              removeCourse={() => removeCourse(course.id)}
            />
          </List.Item>
        )}
      />
    </>
  )
}

export default Archives
